import { initTestimonials } from './testimonials.js';
import { CollectionListDropDown } from "../../controls/collectionListDropdown"
import { ImpressionCardsCarousel } from "../../components/impression-cards-carousel";
import { UpcomingWorkationsCarousel } from "../../components/upcoming-workations-carousel";
import { setInitialWorkationSeasonDropdownItem, updateRoomPrices, updateLengthOfStayDropdownDiscounts, updateAllRoomBookingButtonsUrls } from './rooms-list.js';
import { initLocationMap } from './location-map.js';
import { initUpcomingWorkations } from './upcoming-workations.js';
import { SimpleCardsCarousel } from "../../components/simple-cards.js";
import { FeaturesCardsCarousel } from "../../components/feature-slider";
import { EditionCardsCarousel, updateEditionCardLinkUrls } from "../../components/upcoming-editions";
import { initUpcomingEditionsFilter } from "../../components/upcoming-editions-filter";
import { initReadMore } from "../../utils/readMore.js";

// Make CollectionListDropDown globally accessible for other scripts
window.CollectionListDropDown = CollectionListDropDown;


/*****
***
*** Dropdown init
***
******/

// Initialize the Room Filter Dropdowns
CollectionListDropDown.init({ 
  selector: "#workation-season-dropdown", 
  onChange: (selectedItem) => {
    // Get the location value from the dropdown
    const editionSlug = selectedItem.getAttribute('data-value');
    updateLengthOfStayDropdownDiscounts(editionSlug);
    updateRoomPrices();
    updateAllRoomBookingButtonsUrls();
  }
});

// Initialize the Length of stay Dropdown
CollectionListDropDown.init({ 
  selector: "#length-stay-dropdown", 
  initialValue: 'month-3', 
  onChange: () => updateRoomPrices()
});

// Initialize the Guest Count Dropdown
CollectionListDropDown.init({ 
  selector: "#guest-count-dropdown", 
  initialValue: '1', 
  onChange: () => {
    updateRoomPrices();
    updateAllRoomBookingButtonsUrls();
  }
});

// Initialize the image carousels
ImpressionCardsCarousel.init({selectorId: '#impressions-cards-slider-1', isReverse: false});
ImpressionCardsCarousel.init({selectorId: '#impressions-cards-slider-2', isReverse: true});

// Initialize the Upcoming Workations Carousel
UpcomingWorkationsCarousel.init({
  selectors: {
	  swiper: '#upcoming-workations .swiper',
    swiperWrapper: '#upcoming-workations .swiper-wrapper',
    swiperSlides: '#upcoming-workations .upcoming-workation-card',  
    prevButton: '#upcoming-workations-swiper-prev-btn',
    nextButton: '#upcoming-workations-swiper-next-btn'
  },
  onItemClick: (item) => { 
		const editionSlug = item.getAttribute('data-edition');
    window.CollectionListDropDown.setValue("#workation-season-dropdown", editionSlug);
  }
});

// Initialize the activity cards carousel with a separate instance
const activityCardsCarousel = new SimpleCardsCarousel({
  refContainer: "#activity-cards-swiper-ref-container", // this is needed for calculating the left offset
  swiper: '#activity-cards-section .swiper',
  swiperWrapper: '#activity-cards-section .swiper-wrapper',  
  prevButton: '#activity-cards-swiper-prev-btn',
  nextButton: '#activity-cards-swiper-next-btn'
});
activityCardsCarousel.init();

// Initialize the common facilities cards carousel with a separate instance
const commonFacilitiesCardsCarousel = new SimpleCardsCarousel({
  refContainer: "#common-facilities-cards-swiper-ref-container", // this is needed for calculating the left offset
  swiper: '#common-facilities-cards-section .swiper',
  swiperWrapper: '#common-facilities-cards-section .swiper-wrapper',  
  prevButton: '#common-facilities-cards-swiper-prev-btn',
  nextButton: '#common-facilities-cards-swiper-next-btn'
});
commonFacilitiesCardsCarousel.init();

// Initialize the feature cards carousel
FeaturesCardsCarousel.init({
  swiper: '#features-cards-section .swiper',
  swiperWrapper: '#features-cards-section .swiper-wrapper',  
  prevButton: '#features-cards-btn-left',
  nextButton: '#features-cards-btn-right'
});

// Initialize the carousel
EditionCardsCarousel.init({
  refContainer: "#edition-cards-swiper-ref-container", // this is needed for calculating the left offset
  swiper: '#edition-cards-section .swiper',
  swiperWrapper: '#edition-cards-section .swiper-wrapper',  
  prevButton: '#edition-cards-swiper-prev-btn',
  nextButton: '#edition-cards-swiper-next-btn'
});


/*****
***
*** Initial setup after dom load
***
******/
document.addEventListener('DOMContentLoaded', function() {
  initTestimonials('#destination-testimonials-section');

	// set initial value of the workation season dropdown
	setInitialWorkationSeasonDropdownItem();
  
	// initially update room prices and discounts
	updateRoomPrices();
  updateLengthOfStayDropdownDiscounts();
  
  // update initially all booking button URLs of all rooms
  updateAllRoomBookingButtonsUrls();

  // init location map
  initLocationMap();

  // init upcoming workations
  initUpcomingWorkations();

  // update edition card links
  updateEditionCardLinkUrls();

  // init upcoming editions filter
  initUpcomingEditionsFilter();

  // init read more
  initReadMore();
});

